import { useState } from "react";
import { DataTable } from "../../components/organisms/DataTable";
import { paginacion } from "../../utils/paginacion/paginacion";
import { EstudianteCard } from "./EstudianteCard";

const ESTUDIANTES_POR_PAGINA = 15;

export const EstudianteList = ({ estudiantes = [], onDelete }) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const {
    objetosEnPagina: estudiantesEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, estudiantes, ESTUDIANTES_POR_PAGINA);

  const columnas = ["#", "Nombre", "Apellido", "Código", "Código Región", "Teléfono", "Tipo de Admision", "Grupo", "Género","Credito", "Opciones"];

  const mostrarEstudiantes = estudiantesEnPagina?.length > 0;

  return (
    <DataTable
      columnas={columnas}
      paginas={paginas}
      paginaInicial={paginaInicial}
      paginaFinal={paginaFinal}
      paginaActual={paginaActual}
      setPaginaActual={setPaginaActual}
    >
      {mostrarEstudiantes ? (
        estudiantesEnPagina.map((estudiante, i) => (
          <EstudianteCard
            key={estudiante?.estudiante?.idEstudiante || i}
            estudiante={estudiante}
            index={(paginaActual - 1) * ESTUDIANTES_POR_PAGINA + i}
            onDelete={onDelete}
          />
        ))
      ) : (
        <tr>
          <td colSpan={columnas.length} className="text-center py-4">
            No hay estudiantes inscritos
          </td>
        </tr>
      )}
    </DataTable>
  );
};
